"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../../dsl/backoffice");
/**
 * Simple form component for one expert.
 *
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ExpertForm = class ExpertForm extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.icons = backoffice_1.DashmixIconName;
    }
    /**
     * Paragraph parsed from tag <br>
     */
    get expertDescription() {
        return this.expert.description.replace(/<br\s*[/]?>/gi, '\n');
    }
    /**
     * Paragraph parsed with tag <br>
     */
    set expertDescription(value) {
        this.expert.description = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    }
    /**
     * Function to check if logo has selected image
     */
    hasImage() {
        return !(!this.expert.image || typeof this.expert.image.value === 'undefined');
    }
};
__decorate([
    vue_property_decorator_1.PropSync('expertData', { type: Object, required: true }),
    __metadata("design:type", Object)
], ExpertForm.prototype, "expert", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: '' }),
    __metadata("design:type", String)
], ExpertForm.prototype, "expertThumbnail", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", String)
], ExpertForm.prototype, "disabled", void 0);
ExpertForm = __decorate([
    vue_property_decorator_1.Component({
        name: 'ExpertForm',
        components: {
            DashmixInput: backoffice_1.DashmixInput,
            DashmixTextArea: backoffice_1.DashmixTextArea,
            DashmixFile: backoffice_1.DashmixFile,
            DashmixButton: backoffice_1.DashmixButton
        },
        template: `
    <div class="bg-gray-light py-3 row mx-0 my-3">
      <div class="col-11 p-0">
        <div class="row mx-0">
          <div class="col-12 col-md-8">
            <!-- Expert data -->
            <div class="form-group">
              <label for="expert-name" class="d-block">
                {{ $t('forms.experts.name.label') }}
              </label>
              <DashmixInput size="small" :model.sync="expert.name" name="expert-name"
                            :placeholder="$t('forms.experts.name.placeholder')" />
            </div>

            <div class="form-group">
              <label for="expert-role" class="d-block">
                {{ $t('forms.experts.role.label') }}
              </label>
              <DashmixInput size="small" :model.sync="expert.role" name="expert-role"
                            :placeholder="$t('forms.experts.role.placeholder')" />
            </div>

            <div class="form-group">
              <label for="expert-role" class="d-block">
                {{ $t('forms.experts.description.label') }}
              </label>
              <DashmixTextArea size="small" :model.sync="expertDescription" name="expert-description"
                               :placeholder="$t('forms.experts.description.placeholder')" :rows="3" />
            </div>
          </div>

          <div class="col-12 col-md-4">
            <!-- Expert image -->
            <label>{{ $t('forms.experts.expertImage') }}</label>
            <DashmixButton v-if="!disabled" size="small"
                           variant="alt"
                           class="btn-block"
                           :label="$t('forms.shared.search')"
                           :icon="icons.SearchSolid"
                           @click="() => $emit('selectImage')" />

            <figure v-if="hasImage()" class="figure-with-btn__image-container mt-4">
              <DashmixFile class="figure-with-btn__image" :file="{ thumbnail: expertThumbnail, type: 'jpg' }" />
              <DashmixButton class="figure-with-btn__delete-btn"
                             size="small" variant="icon" :icon="icons.TrashSolid" theme="danger"
                             @click="() => $emit('deleteImage')" />
            </figure>
            <!-- Expert image || END -->
          </div>
        </div>
      </div>

      <div class="col-1 d-flex justify-content-end align-items-center p-0">
        <DashmixButton size="small" variant="icon" :icon="icons.TrashSolid" theme="danger"
                       @click="() => $emit('delete')" />
      </div>
    </div>
  `
    })
], ExpertForm);
exports.ExpertForm = ExpertForm;
//# sourceMappingURL=ExpertForm.js.map